import { numberToWords } from "@/lib/invoiceTemplate";

const inr = (v) => `₹ ${Number(v || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const esc = (s) => String(s ?? "").replace(/[&<>]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;" }[c]));

const EARNINGS = [
  ["basic", "Basic Salary"], ["hra", "House Rent Allowance"], ["conveyance", "Conveyance Allowance"],
  ["special_allowance", "Special Allowance"], ["other_earnings", "Other Earnings"],
];
const DEDUCTIONS = [
  ["pf", "Provident Fund (PF)"], ["professional_tax", "Professional Tax"],
  ["advance", "Advance / Loan"], ["other_deductions", "Other Deductions"],
];

function pageHTML(ps, origin) {
  const gross = ps.gross_earnings ?? EARNINGS.reduce((s, [k]) => s + Number(ps[k] || 0), 0);
  const ded = ps.total_deductions ?? DEDUCTIONS.reduce((s, [k]) => s + Number(ps[k] || 0), 0);
  const net = ps.net_pay ?? gross - ded;

  const earnRows = EARNINGS.map(([k, l]) =>
    `<tr><td>${esc(l)}</td><td class="num">${inr(ps[k])}</td></tr>`).join("");
  const dedRows = DEDUCTIONS.map(([k, l]) =>
    `<tr><td>${esc(l)}</td><td class="num">${inr(ps[k])}</td></tr>`).join("");

  const words = `Indian Rupees ${numberToWords(net)} Only.`;

  return `
  <div class="page">
    <img class="watermark" src="${origin}/vns-logo.png" alt="" />
    <div class="confid">CONFIDENTIAL &mdash; ${esc(ps.employee_name || "")}</div>
    <header>
      <img src="${origin}/vns-logo.png" alt="VNS" />
      <div class="co">
        <h1>VNS Vinayaka Group of Enterprises</h1>
        <div class="sub">Data Entry Division</div>
        <div class="addr">Payslip &mdash; Confidential</div>
      </div>
    </header>
    <div class="title">Payslip for ${esc(ps.month_label || ps.month)}</div>

    <table class="grid">
      <tr>
        <td style="width:50%"><span class="lbl">Employee Name</span><span class="val"><b>${esc(ps.employee_name)}</b></span></td>
        <td style="width:25%"><span class="lbl">Employee ID</span><span class="val">${esc(ps.employee_id)}</span></td>
        <td style="width:25%"><span class="lbl">Pay Period</span><span class="val">${esc(ps.month_label || ps.month)}</span></td>
      </tr>
      <tr>
        <td><span class="lbl">Designation</span><span class="val">${esc(ps.designation || "—")}</span></td>
        <td><span class="lbl">Department</span><span class="val">${esc(ps.department || "—")}</span></td>
        <td><span class="lbl">Date of Joining</span><span class="val">${esc(ps.joining_date || "—")}</span></td>
      </tr>
      <tr>
        <td><span class="lbl">Working Days</span><span class="val">${esc(ps.working_days)}</span></td>
        <td><span class="lbl">Paid Days</span><span class="val">${esc(ps.paid_days)}</span></td>
        <td><span class="lbl">LOP Days</span><span class="val">${esc(ps.lop_days)}</span></td>
      </tr>
    </table>

    <table class="pay">
      <thead><tr><th>Earnings</th><th class="num">Amount</th><th>Deductions</th><th class="num">Amount</th></tr></thead>
      <tbody>
        <tr>
          <td class="half"><table class="inner">${earnRows}</table></td>
          <td class="hide"></td>
          <td class="half"><table class="inner">${dedRows}</table></td>
          <td class="hide"></td>
        </tr>
      </tbody>
      <tfoot>
        <tr class="sub">
          <td>Gross Earnings</td><td class="num">${inr(gross)}</td>
          <td>Total Deductions</td><td class="num">${inr(ded)}</td>
        </tr>
      </tfoot>
    </table>

    <table class="net">
      <tr><td>Net Pay</td><td class="num">${inr(net)}</td></tr>
    </table>
    <div class="words"><b>Net Pay in words:</b> ${esc(words)}</div>
    ${ps.paid_on || ps.payment_mode ? `<div class="pmt"><b>Paid On:</b> ${esc(ps.paid_on || "—")} &nbsp;·&nbsp; <b>Mode:</b> ${esc(ps.payment_mode || "—")}</div>` : ""}
    ${ps.remarks ? `<div class="pmt"><b>Remarks:</b> ${esc(ps.remarks)}</div>` : ""}

    <div class="foot">
      <div class="note">This is a system-generated payslip and does not require a physical signature unless stamped below.</div>
      <div class="sign">
        <img class="stamp" src="${origin}/vns-stamp.png" alt="stamp" onerror="this.style.display='none'"/>
        <div class="sigbox">
          <img class="sig" src="${origin}/vns-signature.png" alt="signature" onerror="this.style.display='none'"/>
          <div class="line">For VNS Vinayaka Group of Enterprises<br/>Authorised Signatory</div>
        </div>
      </div>
    </div>
    <div class="bar">Confidential · VNS Vinayaka Group of Enterprises · Data Entry Division</div>
  </div>`;
}

const STYLE = `
  :root{--navy:#0B2545;--gold:#C5A059;--ink:#0f172a;--line:#c7cdd6;--soft:#f4f6f9;}
  *{box-sizing:border-box;}
  body{margin:0;background:#e9edf2;font-family:Georgia,'Times New Roman',serif;color:var(--ink);}
  .toolbar{position:sticky;top:0;background:#0B2545;color:#fff;padding:10px 16px;font-family:Arial,sans-serif;display:flex;gap:10px;align-items:center;z-index:5;}
  .toolbar button{background:#C5A059;color:#0B2545;border:0;padding:8px 16px;border-radius:6px;font-weight:700;cursor:pointer;}
  .page{width:210mm;min-height:297mm;background:#fff;margin:16px auto;padding:16mm 14mm;box-shadow:0 6px 24px rgba(0,0,0,.15);position:relative;}
  .watermark{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:120mm;max-width:70%;opacity:.06;pointer-events:none;}
  .confid{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%) rotate(-30deg);font-size:30px;font-weight:800;letter-spacing:3px;color:#0B2545;opacity:.07;white-space:nowrap;pointer-events:none;z-index:0;}
  header{display:flex;align-items:center;gap:16px;border-bottom:3px solid var(--gold);padding-bottom:10px;}
  header img{height:66px;width:66px;object-fit:contain;}
  .co h1{margin:0;font-size:19px;color:var(--navy);letter-spacing:.3px;}
  .co .sub{font-family:Arial,sans-serif;font-size:10px;letter-spacing:3px;color:#64748b;text-transform:uppercase;}
  .co .addr{font-family:Arial,sans-serif;font-size:11px;color:#475569;margin-top:4px;}
  .title{text-align:center;font-family:Arial,sans-serif;font-weight:700;font-size:15px;letter-spacing:3px;color:var(--navy);margin:14px 0 10px;text-transform:uppercase;}
  table{width:100%;border-collapse:collapse;}
  .grid td{border:1px solid var(--line);vertical-align:top;padding:6px 8px;font-family:Arial,sans-serif;}
  .lbl{font-size:8.5px;letter-spacing:.5px;text-transform:uppercase;color:#64748b;display:block;margin-bottom:2px;}
  .val{font-size:12px;color:var(--ink);}
  .pay{margin-top:10px;}
  .pay th{background:var(--navy);color:#fff;font-family:Arial,sans-serif;font-size:11px;letter-spacing:.5px;padding:8px;text-align:left;text-transform:uppercase;border:1px solid var(--navy);}
  .pay th.num{text-align:right;}
  .pay .half{border:1px solid var(--line);padding:0;vertical-align:top;width:50%;}
  .pay .hide{display:none;}
  .inner td{border:0;border-bottom:1px solid #eef2f6;padding:8px 10px;font-family:Arial,sans-serif;font-size:12px;}
  .inner td.num{text-align:right;}
  .pay tfoot .sub td{background:var(--soft);font-family:Arial,sans-serif;font-size:12px;font-weight:700;padding:9px 10px;border:1px solid var(--line);color:var(--navy);}
  .pay tfoot .sub td.num{text-align:right;}
  .net{width:52%;margin-left:auto;margin-top:10px;}
  .net td{padding:10px 12px;font-family:Arial,sans-serif;font-size:15px;font-weight:700;background:var(--gold);color:var(--navy);border:1px solid var(--gold);}
  .net td.num{text-align:right;}
  .words{font-family:Arial,sans-serif;font-size:12px;margin-top:8px;padding:8px 10px;background:var(--soft);border:1px solid var(--line);}
  .pmt{font-family:Arial,sans-serif;font-size:11px;color:#475569;margin-top:6px;}
  .foot{display:flex;justify-content:space-between;align-items:flex-end;margin-top:34px;gap:20px;}
  .note{font-family:Arial,sans-serif;font-size:10px;color:#64748b;max-width:60%;font-style:italic;}
  .sign{text-align:center;}
  .sign .stamp{height:64px;display:block;margin:0 auto 2px;}
  .sign .sig{height:36px;margin-bottom:2px;}
  .sign .line{border-top:1px solid #334155;padding-top:4px;font-family:Arial,sans-serif;font-size:10px;color:#334155;width:180px;text-align:center;}
  .bar{background:var(--navy);color:var(--gold);text-align:center;font-family:Arial,sans-serif;font-size:9.5px;letter-spacing:1px;padding:6px;margin-top:16px;border-radius:3px;}
  @media print{body{background:#fff;} .toolbar{display:none;} .page{box-shadow:none;margin:0;page-break-after:always;} .page:last-child{page-break-after:auto;}}
`;

export function openPayslipsBatchPrint(list, label) {
  const origin = window.location.origin;
  const title = `Payslips${label ? " · " + label : ""} (${list.length})`;
  const pages = list.map((ps) => pageHTML(ps, origin)).join("");
  const html = `<!DOCTYPE html><html><head><meta charset="utf-8"/><title>${esc(title)}</title><style>${STYLE}</style></head>
  <body>
    <div class="toolbar"><b>${esc(title)}</b><span style="flex:1"></span><button onclick="window.print()">Print / Save as PDF</button></div>
    ${pages}
  </body></html>`;
  const w = window.open("", "_blank");
  if (!w) return;
  w.document.open();
  w.document.write(html);
  w.document.close();
}

export function openPayslipPrint(ps) {
  const origin = window.location.origin;
  const title = `Payslip ${ps.month_label || ps.month} · ${ps.employee_name || ""}`;
  const html = `<!DOCTYPE html><html><head><meta charset="utf-8"/><title>${title}</title><style>${STYLE}</style></head>
  <body>
    <div class="toolbar"><b>${esc(title)}</b><span style="flex:1"></span><button onclick="window.print()">Print / Save as PDF</button></div>
    ${pageHTML(ps, origin)}
  </body></html>`;
  const w = window.open("", "_blank");
  if (!w) return;
  w.document.open();
  w.document.write(html);
  w.document.close();
}
